import { useState } from 'react';
export const useQuickFiltersVisibility = () => {
  const [quickFiltersVisibility, setQuickFiltersVisibility] = useState({});
  const isQuickFilterVisible = propertyName => {
    return quickFiltersVisibility[propertyName];
  };
  const onQuickFilterVisibilityChange = propertyName => isVisible => {
    if (quickFiltersVisibility[propertyName] !== isVisible) {
      setQuickFiltersVisibility(quickFiltersVisibilityState => Object.assign({}, quickFiltersVisibilityState, {
        [propertyName]: isVisible
      }));
    }
  };
  return {
    isQuickFilterVisible,
    onQuickFilterVisibilityChange
  };
};